module.exports = __webpack_public_path__ + "static/media/arrow-complete-up.6486674f.svg";